import { getLocale } from '../utils/locale'
import type {
  SignUpFormData,
  SignInFormData,
  ResetPasswordFormData,
} from '../types/forms'

import type {
  SignUpResponse,
  SignInResponse,
  ResetPasswordResponse,
  ApiError,
  CurrentCasinoResponse,
  TermsResponse,
} from '../types/api'

const API_BASE_URL = ''

const getHeaders = (): HeadersInit => ({
  'Content-Type': 'application/json; charset=utf-8',
  'X-Locale': getLocale(),
})

const handleResponse = async <T>(response: Response): Promise<T> => {
  let json: unknown

  try {
    json = await response.json()
  } catch {
    json = {}
  }

  if (!response.ok) {
    const error: ApiError = {
      errors: (json as { errors?: Record<string, string[]> }).errors,
      error: (json as { error?: string }).error,
    }
    throw error
  }

  return json as T
}

export const apiService = {
  async signUp(formData: SignUpFormData): Promise<SignUpResponse> {
    const response = await fetch(`${API_BASE_URL}/api/client/partner`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ partner_user: formData }),
    })

    return handleResponse<SignUpResponse>(response)
  },

  async signIn(formData: SignInFormData): Promise<SignInResponse> {
    const response = await fetch(`${API_BASE_URL}/api/client/partner/sign_in`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ partner_user: formData }),
    })

    return handleResponse<SignInResponse>(response)
  },

  async resetPassword(
    formData: ResetPasswordFormData
  ): Promise<ResetPasswordResponse> {
    const response = await fetch(
      `${API_BASE_URL}/api/client/partner/password`,
      {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ partner_user: formData }),
      }
    )

    return handleResponse<ResetPasswordResponse>(response)
  },

  async getTerms(): Promise<TermsResponse> {
    const response = await fetch(`${API_BASE_URL}/api/client/partner/terms`, {
      method: 'GET',
      headers: getHeaders(),
    })

    return handleResponse<TermsResponse>(response)
  },

  async getRegisterFields(): Promise<CurrentCasinoResponse> {
    const response = await fetch(
      `${API_BASE_URL}/api/client/anonymous/current_casino`,
      {
        method: 'GET',
        headers: getHeaders(),
      }
    )

    return handleResponse<CurrentCasinoResponse>(response)
  },

  async trackStag(stag: string): Promise<void> {
    await fetch(`${API_BASE_URL}/api/client/partner/track_stag`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ stag }),
    })
  },
}
